var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { types, getParent } from 'mobx-state-tree';
import { invokeEventHandler } from '../../helpers/ReactShortcuts';
import QueryParameters from '../api/base/models/QueryParameters';
import applyQueryParameters from '../api/base/query/ExpressionBuilder';
import resolveComparator from '../api/base/query/helpers/ComparatorResolver';
var fuzzyComparator = resolveComparator('fuzzy');
var QueryView = function (itemType) { return types.model({
    key: types.identifier,
    queryParameters: QueryParameters,
    itemReferences: types.array(types.safeReference(itemType)),
    loading: types.optional(types.boolean, false)
})
    .named('QueryView')
    .volatile(function (_self) { return ({
    loadMoreHandler: undefined
}); })
    .views(function (self) { return ({
    get referenceOriginal() {
        // if no fuzzy we reference to the list
        return self.queryParameters.filters.find(function (x) { return x.comparator === fuzzyComparator; }) === undefined;
    },
    get allItems() {
        if (this.referenceOriginal) {
            return getParent(self, 2).items;
        }
        return self.itemReferences;
    },
    get items() {
        return applyQueryParameters(this.allItems, self.queryParameters).filter(function (x) { return x !== undefined; });
    },
    get loadMoreToken() {
        return self.queryParameters.getLoadMoreToken(this.items);
    }
}); })
    .actions(function (self) { return ({
    pushItems: function (items) {
        var _a;
        if (self.referenceOriginal) {
            return;
        }
        (_a = self.itemReferences).push.apply(_a, __spreadArray([], __read(items.map(function (x) { return x.id; })), false));
    },
    clearItems: function () {
        self.itemReferences.clear();
    },
    setLoading: function (loading) {
        self.loading = loading;
    },
    setQueryParameters: function (queryParameters) {
        self.queryParameters = queryParameters;
    },
    deleteItems: function (ids) {
        self.itemReferences.replace(self.itemReferences.filter(function (x) { return x && !ids.includes(x.id); }));
    },
    setLoadMoreHandler: function (loadMoreHandler) {
        self.loadMoreHandler = loadMoreHandler;
    },
    loadMore: function () {
        invokeEventHandler(self.loadMoreHandler, self.key);
    }
}); }); };
export default QueryView;
//# sourceMappingURL=QueryView.js.map